
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.167 12.5a5.833 5.833 0 1111.666 0 5.833 5.833 0 01-11.666 0z","stroke":"#FF2D55"}}),_c('path',{attrs:{"d":"M13.75 7.917v-2.5a3.75 3.75 0 10-7.5 0v2.5","stroke":"#FF2D55","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M10 12.5h.008","stroke":"#FF2D55","stroke-width":"1.333","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    